import type {Dispatch} from 'redux';
import {
  CANCEL_NOTIFY_GUESTS_OVERLAY,
  HIDE_NOTIFY_GUESTS_OVERLAY,
  SHOW_NOTIFY_GUESTS_OVERLAY,
} from '~/CreateFabricInvitation/reducers/modals';
import {reduxPromise} from '~/common/middleware/promiseResolver';
import {
  HIDE_LOGIN_MODAL,
  showLoginModal,
  USER_LOGGED_IN,
} from '~library/organisms/LoginModal/reducer';

// Pops the login modal and returns a promise that resolves when the user logs in via the modal (and errors if closed)
export const loginModalPromise = (dispatch: Dispatch) => {
  const promise = reduxPromise(null, [USER_LOGGED_IN], [HIDE_LOGIN_MODAL]);
  dispatch(showLoginModal());
  return promise;
};

// Pops the messages modal and returns a promise that resolves when the modal is closed
export const NotifyGuestsOverlayPromise = (dispatch: Dispatch) => {
  const promise = reduxPromise(null, [HIDE_NOTIFY_GUESTS_OVERLAY], [CANCEL_NOTIFY_GUESTS_OVERLAY]);
  dispatch({type: SHOW_NOTIFY_GUESTS_OVERLAY});
  return promise;
};
